<template>
  <div>
    <top-header v-bind:showReturnBtn="true"
                @ReturnBtnClick="topReturnBtnClick"></top-header>
    <div class="title-container">
      <p style="padding-bottom: 20px;font-size: 30px">{{courseName}}</p>
      <el-button
        type="primary"
        icon="el-icon-plus"
        @click="handleAddLive">创建直播</el-button>
    </div>
    <el-row class="search-container">
      <el-col :span="21">
        <el-row style="padding-top: 20px;padding-left: 20px;">
          <span>直播名称：</span>
          <el-input v-model="searchInfo.searchTitleKey" style="width: 200px"></el-input>
          <span style="padding-left: 20px">课程状态：</span>
          <el-select v-model="searchInfo.searchStatusKey" style="width: 380px" placeholder="请选择">
            <el-option
              v-for="item in liveStatusList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-row>
        <el-row style="padding-left: 20px;padding-top: 20px">
          <span>主讲老师：</span>
          <el-input v-model="searchInfo.searchTeacherKey" style="width: 200px"></el-input>
          <span style="padding-left: 20px">直播时间：</span>
          <el-date-picker style="width: 380px"
                          v-model="searchInfo.searchDateRange"
                          type="datetimerange"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          :default-time="['8:00:00','20:00:00']">
          </el-date-picker>
        </el-row>
      </el-col>
      <el-col :span="3" >
        <el-button type="primary" style="margin-top: 50px;margin-left: 60px" @click="searchBtnClick">搜索</el-button>
      </el-col>
    </el-row>
    <div class="table_container">
      <el-table
        :data="dataList"
        :header-cell-style="{background:'#eef1f6',color:'#606266',textAlign:'center'}"
        style="width: 100%">
        <el-table-column type="expand" width="60">
          <template slot-scope="props">
            <el-form label-position="cen" inline class="demo-table-expand">
              <el-form-item label="直播编号">
                <span>{{ props.row.Id }}</span>
              </el-form-item>
              <el-form-item label="老师">
                <div>
                  <!--                  <el-link style="margin-left: 5px" type="primary" v-for="(item) in props.row.Teachers" @click="teacherNameClick(item)">{{ item.name }}</el-link>-->
                  <el-tag style="margin-right: 5px;margin-top: 5px;cursor: pointer;"
                          :key="item"
                          v-for="(item) in props.row.Teachers" @click="teacherNameClick(item)">
                    {{item.name}}
                  </el-tag>
                </div>
              </el-form-item>
              <el-form-item label="开始时间">
                <span>{{ formatDate('YYYY-mm-dd HH:MM:SS',props.row.BeginTime) }}</span>
              </el-form-item>
              <el-form-item label="直播名称">
                <span>{{ props.row.Title }}</span>
              </el-form-item>
              <el-form-item label="助教">
                <div>
                  <!--                  <el-link style="margin-left: 5px" type="primary" v-for="(item) in props.row.Assistants" @click="teacherNameClick(item)">{{ item.name }}</el-link>-->
                  <el-tag style="margin-right: 5px;margin-top: 5px;cursor: pointer;"
                          :key="item"
                          v-for="(item) in props.row.Assistants" @click="assistantNameClick(item)">
                    {{item.name}}
                  </el-tag>
                </div>
              </el-form-item>
              <el-form-item label="结束时间">
                <span>{{ formatDate('YYYY-mm-dd HH:MM:SS',props.row.EndTime) }}</span>
              </el-form-item>
              <el-form-item label="直播类型">
                <span>{{ getCourseTypeStr(props.row.LiveType) }}</span>
              </el-form-item>
              <el-form-item label="学生">
                <!--                <el-link type="primary" @click="studentsClick(props.row)" style="margin-left: 5px">{{ props.row.MaxUserNum }}</el-link>-->
                <span>{{ props.row.StudentCount }}</span>
              </el-form-item>
              <el-form-item label="创建时间">
                <span>{{ formatDate('YYYY-mm-dd HH:MM:SS',props.row.CreateTime) }}</span>
              </el-form-item>
              <el-form-item label="课程描述">
                <span>{{ props.row.Detail }}</span>
              </el-form-item>
              <el-form-item label="状态">
                <span>{{getLiveStateStr(props.row.LiveState) }}</span>
              </el-form-item>
              <el-form-item label="更新时间">
                <span>{{ formatDate('YYYY-mm-dd HH:MM:SS',props.row.UpdateTime) }}</span>
              </el-form-item>
              <!--<el-form-item label="">-->
              <!--<double-tea-item-live-list-component></double-tea-item-live-list-component>-->
              <!--</el-form-item>-->
            </el-form>
            <!--<double-tea-item-live-list-component-->
              <!--v-if="courseType === 5 && props.row.MasterId === 0"-->
              <!--v-bind:master-id="props.row.Id"-->
              <!--v-bind:course-id="courseId"-->
              <!--style="width: 100%">-->
            <!--</double-tea-item-live-list-component>-->
          </template>
        </el-table-column>
        <el-table-column
          label="直播名称">
          <template slot-scope="props">
            <div style="text-align: center">
              <span>{{ props.row.Title }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="直播时间" width="200">
          <template slot-scope="props">
            <div style="text-align: center">
              <p> {{ formatLiveTime(props.row.BeginTime, props.row.EndTime) }}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="老师">
          <template slot-scope="props">
            <div >
              <!--              <el-link style="margin: 5px" type="primary" v-for="(item, index) in props.row.Teachers" v-if="index < 3" @click="teacherNameClick(item)">{{ item.name }}</el-link>-->
              <el-tag style="margin-right: 5px;margin-top: 5px;cursor: pointer;"
                      :key="item"
                      v-for="(item, index) in props.row.Teachers" v-if="index < 3" @click="teacherNameClick(item)">
                {{item.name}}
              </el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="助教">
          <template slot-scope="props">
            <div>
              <!--              <el-link style="margin: 5px" type="primary" v-for="(item, index) in props.row.Assistants" v-if="index < 3" @click="teacherNameClick(item)">{{ item.name }}</el-link>-->
              <el-tag style="margin-right: 5px;margin-top: 5px;cursor: pointer;"
                      :key="item"
                      v-for="(item, index) in props.row.Assistants" v-if="index < 3" @click="assistantNameClick(item)">
                {{item.name}}
              </el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="学生"
          width="100">
          <template slot-scope="props">
            <div style="text-align: center">
              <!--              <el-link type="primary" @click="studentsClick(props.row)">{{ props.row.MaxUserNum }}</el-link>-->
              <span>{{ props.row.StudentCount }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="250">
          <template slot-scope="scope" >
            <div v-if="scope.row.Status === 1">

              <el-button v-if="courseType === 5"
                size="mini"
                type="primary"
                plain
                @click="handleSubLiveManager(scope.$index, scope.row)">子班管理</el-button>
              <el-button v-else
                size="mini"
                type="primary"
                plain
                @click="handleStuManager(scope.$index, scope.row)">添加学生</el-button>
              <el-button
                size="mini"
                type="primary"
                plain
                @click="handleModifyLive(scope.$index, scope.row)">修改</el-button>
              <el-button
                size="mini"
                type="danger" plain
                @click="handleInvalid(scope.$index, scope.row)">作废</el-button>
            </div>
            <div v-else style="text-align: center;color: red">
              <p>已作废</p>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="Pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50]"
          :page-size="pageCount"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount">
        </el-pagination>
      </div>
    </div>
    <el-dialog title="创建直播" :visible.sync="dialogAddLiveVisible">
      <add-live-component v-bind:live-info="addLiveInfo"
                          @CancleBtnClick="dialogAddLiveVisible = false"
                          @OKBtnClick="addLiveOkBtnClick"></add-live-component>
    </el-dialog>
    <el-dialog title="创建直播" :visible.sync="dialogAddDoubleTeaLiveVisible">
      <add-double-tea-live-component v-bind:live-info="addLiveInfo"
                                     @CancleBtnClick="dialogAddDoubleTeaLiveVisible = false"
                                     @OKBtnClick="addLiveOkBtnClick"></add-double-tea-live-component>
    </el-dialog>
    <el-dialog title="修改直播" :visible.sync="dialogChangeLiveVisible">
      <change-live-component v-bind:live-info="changeLiveInfo"
                             @CancleBtnClick="dialogChangeLiveVisible = false"
                             @OKBtnClick="changeLiveOkBtnClick">
      </change-live-component>
    </el-dialog>
    <el-dialog title="修改直播" :visible.sync="dialogChangeDoubleTeaLiveVisible">
      <add-double-tea-live-component v-bind:live-info="changeLiveInfo"
                                     v-bind:is-add="false"
                                     v-bind:selectMasterClassTitle="changeLiveInfo.MasterName"
                                     v-bind:selectMasterFlag="changeLiveInfo.MasterId !== 0"
                                     @CancleBtnClick="dialogChangeDoubleTeaLiveVisible = false"
                                     @OKBtnClick="changeLiveOkBtnClick">
      </add-double-tea-live-component>
    </el-dialog>
    <el-dialog title="添加学生" :visible.sync="dialogAddStudentVisible" style="padding: 10px" @close="closeStudentDialog">
      <select-user-component ref="addStudentView"
                             @selected="studentSelect"
                             @unSelected="studentNnSelected"
                             @unSelectPageChange="studentNnSelectPageChange"
                             @selectPageChange="studentSelectPageChange"
                             @searchUnSelectClick="studentSearchUnSelectClick"
                             @searchSelectClick="studentSearchSelectClick"></select-user-component>
    </el-dialog>
  </div>
</template>

<script>
  import AddLiveComponent from '../../components/course/AddLiveComponent'
  import TopHeader from '../../components/TopHeader'
  import SelectUserComponent from '../../components/selectuser/SelectUserComponent'
  import ChangeLiveComponent from '../../components/course/ChangeLiveComponent'
  import AddDoubleTeaLiveComponent from '../../components/course/AddDoubleTeaLiveComponent'
  import DoubleTeaItemLiveListComponent from '../../components/course/DoubleTeaItemLiveListComponent'
  export default {
    name: 'CourseLiveManager',
    components: {
      DoubleTeaItemLiveListComponent,
      AddDoubleTeaLiveComponent, ChangeLiveComponent, SelectUserComponent, TopHeader, AddLiveComponent},
    data () {
      return {
        dataList: [],
        courseName: '',
        courseType: 0,
        courseId: 0,
        currentPage: 1,
        pageCount: 10,
        totalCount: 0,
        searchInfo: {searchStatusKey: -1},
        liveStatusList: [{label: '全部', value: -1}, {label: '未开始', value: 0}, {label: '直播中', value: 1}, {label: '已结束', value: 2}],
        addLiveInfo: {Teachers: [], Assistants: [], BeginTime: new Date(), courseMasterType: 0},
        dialogAddLiveVisible: false,
        changeLiveInfo: {},
        dialogChangeLiveVisible: false,
        dialogAddStudentVisible: false,
        curLiveIdByAddStu: 0,
        dialogAddDoubleTeaLiveVisible: false,
        dialogChangeDoubleTeaLiveVisible: false
      }
    },
    created () {
      this.courseId = this.$route.query.courseId
      this.getCourseName()
    },
    watch: {
      '$route': {
        handler (route) {
          const that = this
          if (route.path === '/liveCourse') {
            this.courseId = this.$route.query.courseId
            that.getLiveByCurParams()
            that.getCourseName()
          }
        },
        deep: true
      }
    },
    methods: {
      getCourseName () {
        let requestData = {id: this.$route.query.courseId}
        this.$api.courseManager.getCourseName(requestData).then((res) => {
          if (res.code === 0) {
            this.courseName = res.name
            this.courseType = res.type
            this.getLiveByCurParams()
          }
        })
      },
      getLiveByCurParams () {
        let title = this.searchInfo.searchTitleKey
        let teacherName = this.searchInfo.searchTeacherKey
        let dateRange = this.searchInfo.searchDateRange
        let liveStatus = this.searchInfo.searchStatusKey
        let hasSearchKey = false
        let requestData = {couseid: this.$route.query.courseId, count: this.pageCount, page: this.currentPage}
        if (title !== undefined) {
          requestData.title = title
          hasSearchKey = true
        }
        if (teacherName !== undefined) {
          requestData.teacher = teacherName
          hasSearchKey = true
        }
        if (liveStatus !== -1) {
          requestData.status = liveStatus
          hasSearchKey = true
        }
        if (dateRange !== undefined && dateRange.length > 1) {
          hasSearchKey = true
          requestData.begintime = this.formatDate('YYYY-mm-dd HH:MM:SS', dateRange[0])
          requestData.endtime = this.formatDate('YYYY-mm-dd HH:MM:SS', dateRange[1])
        }
        // 如果是双师课，并且没有搜索条件走/masterlive接口
        if (this.courseType === 5 && !hasSearchKey) {
          requestData = {courseid: this.$route.query.courseId, count: this.pageCount, page: this.currentPage}
          this.$api.courseManager.getMasetLiveByCourse(requestData).then((res) => {
            if (res.code === 0) {
              this.formatResultLiveData(res)
            }
          })
          return
        }


        this.$api.courseManager.getSearchLiveList(requestData).then((res) => {
          if (res.code === 0) {
            this.formatResultLiveData(res)
          }
        })
      },
      formatResultLiveData (res) {
        if (res.data !== null) {
          this.dataList = res.data
          for (let i = 0; i < this.dataList.length; i++) {
            let liveObj = this.dataList[i]
            if (liveObj.Teachers !== null && liveObj.Teachers !== undefined && liveObj.Teachers !== '') {
              let teacherList = JSON.parse(liveObj.Teachers)
              liveObj.Teachers = teacherList
            }
            if (liveObj.Assistants !== null && liveObj.Assistants !== undefined && liveObj.Assistants !== '') {
              let assistantList = JSON.parse(liveObj.Assistants)
              liveObj.Assistants = assistantList
            }
          }
          this.totalCount = res.count
        }
        else {
          this.dataList = null
        }
      },
      topReturnBtnClick () {
        this.$router.push({path: '/courseop'})
      },
      handleSizeChange (val) {
        this.pageCount = val
        this.currentPage = 1
        this.getLiveByCurParams()
      },
      handleCurrentChange (val) {
        this.currentPage = val
        this.getLiveByCurParams()
      },
      searchBtnClick () {
        this.currentPage = 1
        this.getLiveByCurParams()
      },
      handleAddLive () {
        this.$api.home.interCheck().then((res) => {

        })
        // if (this.courseType === 5) {
        //   // this.addLiveInfo.BeginTime = new Date()
        //   // debugger
        //   // this.addLiveInfo.courseMasterType = 0
        //   this.dialogAddDoubleTeaLiveVisible = true
        // } else {
          // this.addLiveInfo.BeginTime = new Date()
          this.dialogAddLiveVisible = true
        // }

      },
      teacherNameClick (item) {
        console.log(item)
        this.$router.push({path: '/teacherInfo', query: {teacherId: item.account}})
      },
      assistantNameClick (item) {
        console.log(item)
      },
      studentsClick (row) {

      },
      addLiveOkBtnClick () {
        this.dialogAddLiveVisible = false
        this.dialogAddDoubleTeaLiveVisible = false
        if (this.addLiveInfo.BeginTime !== undefined && this.addLiveInfo.EndTime !== undefined) {
          let beginTime = this.formatDate('YYYY-mm-dd HH:MM:SS', this.addLiveInfo.BeginTime)
          let endTime = this.formatDate('YYYY-mm-dd HH:MM:SS', this.addLiveInfo.EndTime)
          let teacherStr = this.formatTeacherListStr(this.addLiveInfo.Teachers)
          let assistantStr = this.formatAssistantListStr(this.addLiveInfo.Assistants)
          let masterid = 0

          if (this.addLiveInfo.courseMasterType !== 0) {
            masterid = this.addLiveInfo.masterId
          }
          let requestData = {courseid: parseInt(this.$route.query.courseId),
            title: this.addLiveInfo.Title,
            begintime: beginTime,
            endtime: endTime,
            teachers: teacherStr,
            assistants: assistantStr,
            detail: this.addLiveInfo.Detail,
            masterid: masterid,
            subClassName: ''
          }
          this.$api.courseManager.addLive(requestData).then((res) => {
            if (res.code === 0) {
              this.$message({
                type: 'success',
                message: '添加成功'
              })
              this.getLiveByCurParams()
              this.addLiveInfo = {Teachers: [], Assistants: [], BeginTime: new Date(), courseMasterType: 0}
            }
          })
        }
      },
      handleSubLiveManager (index, row) {
        this.$router.push({path: '/subLiveManager', query: {masterLiveId: row.Id, courseId: this.courseId}})
      },
      handleModifyLive (index, row) {
        this.$api.home.interCheck().then((res) => {

        })
        this.changeLiveInfo = this.deepCopy(row)
        this.changeLiveInfo.Teachers = this.formatTeacherListKey(this.changeLiveInfo.Teachers)
        this.changeLiveInfo.Assistants = this.formatAssistantListKey(this.changeLiveInfo.Assistants)
        this.changeLiveInfo.LiveTime = []
        // this.changeLiveInfo.LiveTime.push(new Date(this.changeLiveInfo.BeginTime))
        // this.changeLiveInfo.LiveTime.push(new Date(this.changeLiveInfo.EndTime))
        this.changeLiveInfo.BeginTime = new Date(this.changeLiveInfo.BeginTime)
        this.changeLiveInfo.EndTime = new Date(this.changeLiveInfo.EndTime)
        // if (this.courseType === 5) {
        //   this.dialogChangeDoubleTeaLiveVisible = true
        //   this.changeLiveInfo.courseMasterType = 0
        // } else {
          this.dialogChangeLiveVisible = true
        // }

      },
      changeLiveOkBtnClick () {
        this.dialogChangeLiveVisible = false
        this.dialogChangeDoubleTeaLiveVisible = false
        if (this.changeLiveInfo.BeginTime !== undefined && this.changeLiveInfo.EndTime !== undefined) {
          let beginTime = this.formatDate('YYYY-mm-dd HH:MM:SS', this.changeLiveInfo.BeginTime)
          let endTime = this.formatDate('YYYY-mm-dd HH:MM:SS', this.changeLiveInfo.EndTime)
          let teacherStr = this.formatTeacherListStr(this.changeLiveInfo.Teachers)
          let assistantStr = this.formatAssistantListStr(this.changeLiveInfo.Assistants)
          let requestData = {
            id: this.changeLiveInfo.Id,
            title: this.changeLiveInfo.Title,
            begintime: beginTime,
            endtime: endTime,
            teachers: teacherStr,
            assistants: assistantStr
          }
          this.$api.courseManager.modifyLive(requestData).then((res) => {
            if (res.code === 0) {
              this.$message({
                type: 'success',
                message: '修改成功'
              })
              this.getLiveByCurParams()
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      },
      // 添加学生相关
      closeStudentDialog () {
        this.$refs.addStudentView.release()
        this.getLiveByCurParams()
      },
      handleStuManager (index, row) {
        this.curLiveIdByAddStu = row.Id
        this.dialogAddStudentVisible = true
        if (this.$refs.addStudentView === undefined) {
          let that = this
          setTimeout(function () {
            that.getunAddedStu(5, 1)
            that.getAddedStu(5, 1)
          }, 100)
        } else {
          this.getunAddedStu(5, 1)
          this.getAddedStu(5, 1)
        }
      },
      getunAddedStu (count, page) {
        let searchKey = this.$refs.addStudentView.searchVal
        console.log(searchKey)
        if (searchKey !== '') {
          let requestData = {liveid: this.curLiveIdByAddStu, count: count, page: page, key: searchKey}
          this.$api.courseManager.getUnAddedStuBySearchLive(requestData).then((res) => {
            if (res.code === 0) {
              let allStu = res.data
              this.$refs.addStudentView.setUnSelectList(allStu, res.count)
            }
          })
        } else {
          let requestData = {id: this.curLiveIdByAddStu, count: count, page: page}
          this.$api.courseManager.getUnAddedStuByLive(requestData).then((res) => {
            if (res.code === 0) {
              let allStu = res.data
              this.$refs.addStudentView.setUnSelectList(allStu, res.count)
            }
          })
        }
      },
      getAddedStu (count, page) {
        let searchKey = this.$refs.addStudentView.searchRightVal
        if (searchKey !== '') {
          let requestData = {count: count, page: page, liveid: this.curLiveIdByAddStu, key: searchKey}
          this.$api.courseManager.getAddedStuBySearchLive(requestData).then((res) => {
            if (res.code === 0) {
              this.$refs.addStudentView.setSelectList(res.data, res.count)
            }
          })
        } else {
          let requestData = {count: count, page: page, liveid: this.curLiveIdByAddStu}
          this.$api.courseManager.getAddedStuByLive(requestData).then((res) => {
            if (res.code === 0) {
              this.$refs.addStudentView.setSelectList(res.data, res.count)
            }
          })
        }
      },
      studentSelect (item) {
        let requestData = {userid: item.Id, liveid: this.curLiveIdByAddStu}
        this.$api.courseManager.addStuToLive(requestData).then((res) => {
          if (res.code === 0) {
            // 重新获取未添加到直播的学生
            let unSelectCurPage = this.$refs.addStudentView.getUnSelectCurPage()
            this.getunAddedStu(this.$refs.addStudentView.pageSize, unSelectCurPage)

            this.$refs.addStudentView.selectedSuccess(item)
            // let selectCurPage = this.$refs.addStudentView.getSelectCurPage()
            // this.getAddedStu(this.$refs.addStudentView.pageSize, selectCurPage)
          } else {
            this.$message.error(res.msg)
          }
        })
      },
      studentNnSelected (item) {
        let requestData = {userid: item.Id, liveid: this.curLiveIdByAddStu}
        this.$api.courseManager.delStuToLive(requestData).then((res) => {
          if (res.code === 0) {
            let selectCurPage = this.$refs.addStudentView.getSelectCurPage()
            this.getAddedStu(this.$refs.addStudentView.pageSize, selectCurPage)

            this.$refs.addStudentView.unSelectedSuccess(item)
            // let unSelectCurPage = this.$refs.addStudentView.getUnSelectCurPage()
            // this.getunAddedStu(this.$refs.addStudentView.pageSize, unSelectCurPage)
          } else {
            this.$message.error(res.msg)
          }
        })
      },
      studentNnSelectPageChange (pageSize, index) {
        this.getunAddedStu(pageSize, index)
      },
      studentSelectPageChange (pageSize, index) {
        this.getAddedStu(pageSize, index)
      },
      studentSearchUnSelectClick (searchKey) {
        let selectCurPage = 1// this.$refs.addStudentView.getUnSelectCurPage()
        this.getunAddedStu(this.$refs.addStudentView.pageSize, selectCurPage)
      },
      studentSearchSelectClick (serachKey) {
        let selectCurPage = 1// this.$refs.addStudentView.getSelectCurPage()
        this.getAddedStu(this.$refs.addStudentView.pageSize, selectCurPage)
      },
      handleInvalid (index, row) {
        let requestData = {id: row.Id}
        this.$api.courseManager.deleteLive(requestData).then((res) => {
          if (res.code === 0) {
            this.$message({
              type: 'success',
              message: '作废成功'
            })
            this.getLiveByCurParams()
          } else {
            this.$message.error(res.msg)
          }
        })
      },
      formatTeacherListKey (teachers) {
        let resultList = []
        for (let i = 0; i < teachers.length; i++) {
          let item = teachers[i]
          let resItem = {Id: item.account, Name: item.name}
          resultList.push(resItem)
        }
        return resultList
      },
      formatAssistantListKey (assistants) {
        let resultList = []
        for (let i = 0; i < assistants.length; i++) {
          let item = assistants[i]
          let resItem = {Id: item.account, Name: item.name}
          resultList.push(resItem)
        }
        return resultList
      },
      formatAssistantListStr (assistants) {
        let resultList = []
        for (let i = 0; i < assistants.length; i++) {
          let item = assistants[i]
          let resItem = {account: item.Id, name: item.Name}
          resultList.push(resItem)
        }
        return JSON.stringify(resultList)
      },
      formatTeacherListStr (teachers) {
        let resultList = []
        for (let i = 0; i < teachers.length; i++) {
          let item = teachers[i]
          let resItem = {account: item.Id, name: item.Name, introduce: '', nick: item.Nick, headImg: ''}
          resultList.push(resItem)
        }
        return JSON.stringify(resultList)
      },
      formatLiveTime (beginTime, endTime) {
        let timeStr = this.formatDate('YYYY-mm-dd HH:MM', beginTime) + ' - ' + this.formatDate('HH:MM', endTime)
        return timeStr
      },
      formatDate (fmt, dateStr) {
        let date = new Date(dateStr)
        let ret
        let opt = {
          'Y+': date.getFullYear().toString(),
          'm+': (date.getMonth() + 1).toString(),
          'd+': date.getDate().toString(),
          'H+': date.getHours().toString(),
          'M+': date.getMinutes().toString(),
          'S+': date.getSeconds().toString()
        }
        for (let k in opt) {
          ret = new RegExp('(' + k + ')').exec(fmt)
          if (ret) {
            fmt = fmt.replace(ret[1], (ret[1].length === 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, '0')))
          };
        };
        return fmt
      },
      deepCopy (obj) {
        let result = Array.isArray(obj) ? [] : {}
        for (let key in obj) {
          if (obj.hasOwnProperty(key)) {
            if (typeof obj[key] === 'object' && obj[key] !== null) {
              result[key] = this.deepCopy(obj[key])
            } else {
              result[key] = obj[key]
            }
          }
        }
        return result
      },
      getLiveStateStr (state) {
        switch (state) {
          case 0 :
            return '未开始'
          case 1 :
            return '直播中'
          case 2 :
            return '已结束'
          default:
            return 'type:' + state
        }
      },
      getCourseTypeStr (courseType) {
        switch (courseType) {
          case 0 :
            return '小班课'
          case 1 :
            return '大班课'
          case 2 :
            return '公开课'
          case 5 :
            return '双师课'
          default:
            return 'type:' + courseType
        }
      }
    }
  }
</script>

<style scoped>
  .table_container{
    padding: 20px;
  }
  .Pagination{
    text-align: center;
  }
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    text-align: justify;
    margin-right: 0;
    margin-bottom: 0;
    width: 33%;
  }
  .title-container{
    margin: 30px;
  }
  .search-container{
    margin: 20px;
    height: 130px;
    background-color: #EFF1F6;
  }

</style>



// WEBPACK FOOTER //
// src/page/courseManager/CourseLiveManager.vue